import {
    finishReferralClaim,
    markReferralClaimPending,
    retryReferralClaim,
} from "@/entities/referral";
import {
    userApi,
    type EnsureUserPayload,
    type EnsuredUser,
    type User,
} from "../api/user.api";

type AccessToken = string | null | undefined;

type UserStore = {
    getUser: (id: string) => Promise<User | null>;
    ensureUser: (payload: EnsureUserPayload) => Promise<EnsuredUser>;
};

export async function loadStoredUser(
    userId: string,
    profile: Pick<EnsureUserPayload, "email" | "givenName" | "familyName">,
    getToken: () => Promise<AccessToken>,
    store: UserStore = userApi
): Promise<User> {
    const data = await store.getUser(userId);
    if (data) {
        await retryReferralClaim(userId, getToken);
        return data;
    }

    // Флаг до POST. Потерянный ответ ensureUser не должен пропускать claim.
    markReferralClaimPending(userId);
    const ensured = await store.ensureUser({
        id: userId,
        email: profile.email,
        givenName: profile.givenName,
        familyName: profile.familyName,
    });
    await finishReferralClaim(userId, getToken);
    return ensured.user;
}
